<template>
  <BaseVisualBanner
    v-if="showBanner"
    :heading="$t('treatwell_marketplace_banner.title')"
    :description="$t('treatwell_marketplace_banner.description')"
    imagePath="/img/empty-states/treatwell.svg"
    :secondaryAction="{text: $t('treatwell_marketplace_banner.cta'), routerLink: {name: 'treatwell-admin'}}"
    v-test="'treatwell-marketplace-banner'"
  />
</template>

<script
  lang="ts"
  setup
>
import { useTreatwellStore } from '@/stores/treatwell';

const { showTreatwell, treatwellStatus, completedOnboardingTasks } =
  useTreatwellStore();

const showBanner = computed(() => {
  return (
    showTreatwell &&
    !completedOnboardingTasks &&
    !treatwellStatus.freeCommissionRemainingDays &&
    treatwellStatus.hasVenue &&
    treatwellStatus.venuePending
  );
});
</script>
